import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock, ShieldCheck, Download } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="comprar" className="bg-navy-900 py-10 md:py-14 relative text-cream-50" data-id="element-212">
      <div className="container mx-auto px-4" data-id="element-213">
        <div className="max-w-[720px] mx-auto" data-id="element-214">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-215">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-216" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-217" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-218" />
          </div>
          <FadeIn data-id="element-219">
            <div className="text-center mb-6" data-id="element-220">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-221">
                Recupera tus noches y tu vitalidad hoy mismo.
              </h2>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-222">
            <div className="bg-navy-800 rounded-3xl shadow-2xl border border-gold-500/30 overflow-hidden" data-id="element-223">
              <div className="bg-navy-950 p-6 text-center relative overflow-hidden" data-id="element-224">
                <div className="absolute top-0 right-0 w-32 h-32 bg-gold-500/10 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-225" />
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold-500/10 rounded-full -ml-16 -mb-16 blur-2xl" data-id="element-226" />

                <h3 className="text-2xl font-heading font-bold text-white mb-1 relative z-10" data-id="element-227">
                  Protocolo Próstata: Noches en Paz
                </h3>
                <p className="text-gold-400 font-medium mb-4 relative z-10" data-id="element-228">
                  Acceso Inmediato
                </p>

                <div className="flex justify-center items-baseline gap-2 relative z-10" data-id="element-229">
                  <span className="text-3xl text-cream-100/60 font-bold line-through" data-id="element-230">
                    $40
                  </span>
                  <span className="text-6xl font-bold text-white" data-id="element-231">$6.39</span>
                  <span className="text-xl text-cream-100/80" data-id="element-232">USD</span>
                </div>
                <div className="mt-2 relative z-10" data-id="element-233">
                  <span className="inline-block bg-gold-500/20 text-gold-400 font-bold text-sm px-4 py-1.5 rounded-full border border-gold-500/30" data-id="element-234">
                    🔥 84% DE DESCUENTO
                  </span>
                </div>
                <p className="text-cream-100/60 text-sm mt-1.5 relative z-10" data-id="element-235">
                  Pago único. Sin suscripciones.
                </p>
              </div>

              <div className="p-6 md:p-8" data-id="element-236">
                <div className="flex justify-center mb-6" data-id="element-237">
                  <img src="https://cdn.magicpatterns.com/uploads/eVPGx4bf25Dj1a1Lq4KT22/image_(2).png" alt="Hombre leyendo el Protocolo Próstata: Noches en Paz en su tablet por la noche" className="w-full max-w-[300px] rounded-xl shadow-lg border border-gold-500/20 object-cover" data-id="element-238" />
                </div>

                <ul className="space-y-3 mb-6" data-id="element-239">
                  <li className="flex items-center gap-3" data-id="element-240">
                    <Download className="text-gold-500 shrink-0" size={24} data-id="element-241" />
                    <span className="text-lg text-cream-100/90 font-medium" data-id="element-242">
                      Protocolo Próstata: Noches en Paz en PDF
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-243">
                    <Download className="text-gold-500 shrink-0" size={24} data-id="element-244" />
                    <span className="text-lg text-cream-100/90 font-medium" data-id="element-245">
                      BONO #1 (Plan de Cenas 7 días)
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-246">
                    <Download className="text-gold-500 shrink-0" size={24} data-id="element-247" />
                    <span className="text-lg text-cream-100/90 font-medium" data-id="element-248">
                      BONO #2 (Guía 3AM)
                    </span>
                  </li>
                </ul>

                <div className="bg-navy-900 rounded-xl p-4 mb-6 text-center border border-navy-700" data-id="element-249">
                  <p className="text-cream-100/80 italic text-lg" data-id="element-250">
                    "Es menos de lo que cuesta una cena… y esa cena
                    probablemente es la que te estaba despertando."
                  </p>
                </div>

                <Button href="https://epikkastore.com/cart/44917431238679:1" className="w-full text-xl py-6 mb-3 shadow-xl shadow-gold-500/20" onClick={trackAddToCart} data-id="element-251">
                  ¡QUIERO DORMIR TODA LA NOCHE! — DESCARGAR AHORA
                </Button>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-cream-100/50 mt-4" data-id="element-252">
                  <div className="flex items-center gap-1" data-id="element-253">
                    <Download size={16} data-id="element-254" />
                    <span data-id="element-255">Acceso instantáneo en formato PDF.</span>
                  </div>
                  <div className="hidden sm:block w-1 h-1 rounded-full bg-cream-100/30" data-id="element-256" />
                  <div className="flex items-center gap-1" data-id="element-257">
                    <Lock size={16} data-id="element-258" />
                    <span data-id="element-259">Pago seguro y privado.</span>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-260">
            <div className="mt-8 flex items-center justify-center gap-2 text-cream-100/40" data-id="element-261">
              <ShieldCheck size={24} data-id="element-262" />
              <span className="text-sm font-medium" data-id="element-263">
                Garantía de Satisfacción 100% Segura
              </span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}